<div class="mt-4 flex justify-between gap-x-4">
  @if (steps.length > 0) {
    <ol
      class="flex items-center w-auto p-3 space-x-2 text-sm font-medium text-center text-body bg-amazone-orange border border-amazone-orange rounded-md shadow-xs sm:px-4 sm:py-2 sm:space-x-4 rtl:space-x-reverse"
    >
      @for (step of steps; track $index) {
        <li [ngClass]="step.isActive ? '' : 'opacity-50'" class="flex items-center text-white">
          <span class="flex items-center justify-center w-5 h-5 me-2 text-xs border border-white rounded-full shrink-0">
            {{ step.index }}
          </span>
          {{ step.label }}
          @if (!isLastStepActive) {
            <svg
              class="w-5 h-5 ms-2 rtl:rotate-180"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="m7 16 4-4-4-4m6 8 4-4-4-4"
              />
            </svg>
          }
        </li>
      }
    </ol>
  }

  <div class="flex gap-x-2">
    <button
      (click)="cancelSteps()"
      type="button"
      class="disabled:cursor-not-allowed disabled:opacity-50 my-auto cursor-pointer inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold text-amazone-orange ring-1 shadow-xs hover:scale-105 transition ease-in-out sm:mt-0 sm:w-auto"
      appAgentAction
      agent="stepper-cancel"
      action="cancel"
    >
      Cancel
    </button>
    @if (isLastStepActive) {
      @if (!isFirstStepActive) {
        <button
          (click)="previous()"
          type="button"
          class="disabled:cursor-not-allowed disabled:opacity-50 my-auto cursor-pointer inline-flex w-full justify-center rounded-md bg-amazone-orange px-3 py-2 text-sm font-semibold text-gray-50 ring-1 shadow-xs hover:scale-105 transition ease-in-out sm:mt-0 sm:w-auto"
          appAgentAction
          agent="stepper-previous"
          action="previous"
        >
          Previous
        </button>
      }
      <button
        (click)="confirmSteps()"
        type="button"
        class="disabled:cursor-not-allowed disabled:opacity-50 my-auto cursor-pointer inline-flex w-full justify-center rounded-md bg-amazone-orange px-3 py-2 text-sm font-semibold text-gray-50 ring-1 shadow-xs hover:scale-105 transition ease-in-out sm:mt-0 sm:w-auto"
        appAgentAction
        agent="stepper-confirm"
        action="confirm"
      >
        Confirm
      </button>
    } @else {
      @if (!isFirstStepActive) {
        <button
          (click)="previous()"
          type="button"
          class="disabled:cursor-not-allowed disabled:opacity-50 my-auto cursor-pointer inline-flex w-full justify-center rounded-md bg-amazone-orange px-3 py-2 text-sm font-semibold text-gray-50 ring-1 shadow-xs hover:scale-105 transition ease-in-out sm:mt-0 sm:w-auto"
          appAgentAction
          agent="stepper-previous"
          action="previous"
        >
          Previous
        </button>
      }
      <button
        (click)="next()"
        type="button"
        class="disabled:cursor-not-allowed disabled:opacity-50 my-auto cursor-pointer inline-flex w-full justify-center rounded-md bg-amazone-orange px-3 py-2 text-sm font-semibold text-gray-50 ring-1 shadow-xs hover:scale-105 transition ease-in-out sm:mt-0 sm:w-auto"
        appAgentAction
        agent="stepper-next"
        action="next"
      >
        Next
      </button>
    }
  </div>
</div>
